import { StatusStyle } from "../styles/Status";

const orange = "#fcaf00";
const green = "#23b574";
const red = "#b30606";
const black = "#000006";

export const Suspended = ({ message = "Suspenso" }) => (
  <StatusStyle color={black}>{message}</StatusStyle>
);

export const Open = () => <StatusStyle color={orange}>Em aberto</StatusStyle>;

export const Late = () => <StatusStyle color={red}>Atrasado</StatusStyle>;

export const Closeded = () => <StatusStyle color={green}>Faturado</StatusStyle>;

export const enumContractStatus = {
  C: <Closeded />,
  A: <Open />,
  S: <Suspended />,
};

export const enumAccountsStatus = {
  Cancelado: <Suspended message="Cancelado" />,
  Aberto: <Open />,
  Suspenso: <Suspended />,
  "Recup Credito": <Suspended message="Recup Credito" />,
  "Em Cobranca": <Open />,
  "Em Cartorio": <Open />,
  Protestado: <Open />,
  "Liquidado Parcialmente": <Open />,
  "Liquidado Totalmente": <Closeded />,
  "Desconto de Titulo - Factoring": (
    <Suspended message="Desconto de Titulo - Factoring" />
  ),
  "Aguardando Baixa": <Suspended message="Aguardando Baixa" />,
  Baixado: <Suspended message="Baixado" />,
  "Depto Juridico - Negociando": <Open />,
  Renegociado: <Suspended message="Renegociado" />,
};
